@if (icon) {
  <fa-icon [icon]="icon | scIcon" [ngClass]="iconColor" class="me-1"></fa-icon>
}
@if (rendering?.fields?.content?.value) {
  <wl-rich-text [rendering]="rendering" class="align-items-center">
  </wl-rich-text>
}
